<script>
import { signUpNewsletter } from '../../api/newsletter';
import { emailRegex } from '../../constants';
import fire from '../../firebase';
const db = fire.firestore();

export default {
  name: 'CpSocialFeedSubscribeToNewsletter',
  components: {
    CpButton: require('../../button').default,
    CpTextInput: require('../../inputs/text').default,
    CpToasted: require('../../toasted').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
  },
  props: {
    user: { type: Object },
  },
  data() {
    return {
      email: '',
      loading: false,
      isSubscribeToNewsletter: false,
      toasted: [],
      errorMessage: '',
    };
  },
  mounted() {
    if (this.user) {
      this.getSubscriptionToNewsletter();
    }
  },
  methods: {
    async getSubscriptionToNewsletter() {
      try {
        const userRef = db.collection('users').doc(`${this.user.id}`);
        if (!userRef) throw new Error('User not found');

        const topicDocRef = userRef.collection('topics').doc('newsletters');
        const topicDocSnapshot = await topicDocRef.get();
        this.isSubscribeToNewsletter = topicDocSnapshot.exists;
      } catch (error) {
        console.error(error);
      }
    },
    async handleSubscribe() {
      this.errorMessage = '';
      this.loading = true;
      if (this.isSubmitAllowed) {
        await signUpNewsletter({ email: this.email })
          .then(() => {
            this.email = '';
            this.createAlert({ message: 'Successfully subscribed to Daily Newsletter!' });
          })
          .catch(error => {
            console.warn(error);
            this.createAlert({ message: 'An error has occurred, try again!', theme: 'danger' });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.errorMessage = 'A valid email address is required';
      }
    },
    createAlert({ message, theme = 'success', duration = 2000 }) {
      this.toasted.push({ key: `alert-${new Date().toString()}`, message, theme, duration });
    },
  },
  computed: {
    isSubmitAllowed() {
      return emailRegex.test(this.email) && this.email;
    },
  },
};
</script>

<template>
  <div v-if="!isSubscribeToNewsletter" class="container">
    <div class="alerts">
      <CpToasted v-for="toast in toasted" :key="toast.key" :message="toast.message" :theme="toast.theme" :duration="toast.duration" />
    </div>
    <h3 class="subheadline1 primary-color text-center text">Subscribe to CrowdBlue's Daily News</h3>
    <p class="footnote neutral4-color text-center text">
      Sign up to receive our daily newsletter of trending headlines, CrowdBlue campaigns, lobbies, petitions, and more.
    </p>
    <CpTextInput block round v-model="email" placeholder="Email" v-margin-bottom="1"></CpTextInput>
    <CpButton primary block @click="handleSubscribe" :loading="loading" :disabled="loading">Sign Up</CpButton>
    <p v-if="errorMessage" class="footnote error-color"><i class="fas fa-exclamation-circle error-color"></i>&nbsp;{{ errorMessage }}</p>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  border: 1px solid var(--primary-blue-500);
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px #00000033;
  background-color: var(--white);
}

.alerts {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.text {
  padding: 0 16px;
}

@media screen and (max-width: 768px) {
  .container {
    max-width: 250px;
  }
}
</style>
